const ContactMe = () =>{
  return (<a href="mailto:chelsirawat13@gmail.com" className="mail-container">
          Contact Me
      </a>);
}

export default ContactMe;